<template>
  <b-form-group>
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text v-if="filtrarAoDigitar"><i class="fa fa-search"></i></b-input-group-text>
        <b-button variant="primary" v-else @click="aplicarFiltro" title="Pesquisar"><i class="fa fa-search"></i></b-button>
      </b-input-group-prepend>
      <b-form-input type="text"
        placeholder=""
        v-model="filtro"
        @keyup.enter="aplicarFiltro">
      </b-form-input>
      <b-input-group-append>
        <b-button variant="primary" @click="limparFiltro">Limpar</b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
  export default {
    name: 'app-filtro-tabela',
    data () {
      return {
        filtro: ''
      }
    },
    props: {
      value: {
        type: String || Number
      },
      filtrarAoDigitar: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      aplicarFiltro () {
        if (!this.filtrarAoDigitar) {
          this.$emit('input', this.filtro)
        }
      },
      limparFiltro () {
        this.filtro = ''
        if (!this.filtrarAoDigitar) {
          this.$emit('input', this.filtro)
        }
      }
    },
    watch: {
      filtro () {
        if (this.filtrarAoDigitar) {
          this.$emit('input', this.filtro)
        }
      }
    }
  }
</script>
